import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "calc"
    }}>{`calc`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{` UXP v3.0`}</p>
    <p>{`You can use `}<inlineCode parentName="p">{`calc`}</inlineCode>{` to evaluate arbitrary expressions in the context of a CSS style rule. `}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/CSS/calc"
      }}>{`https://developer.mozilla.org/en/docs/Web/CSS/calc`}</a></p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.someElement {
    width: calc(100vh - 50px);
}
`}</code></pre>
    <h2 {...{
      "id": "quirks-and-exceptions"
    }}>{`Quirks and Exceptions`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`calc`}</inlineCode>{` works for length values, not colors. However, you `}<em parentName="li">{`can`}</em>{` use `}<inlineCode parentName="li">{`calc`}</inlineCode>{` for the numeric portions of an `}<inlineCode parentName="li">{`rgb()`}</inlineCode>{` color.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      